import * as S from "react";
import { useState as O, useCallback as d, useEffect as _ } from "react";
import { w } from "./use-sync-external-store-9c68af99.js";
import { i as x } from "./use-isomorphic-layout-effect-37cd9e90.js";
import { i as T, I as y, S as b } from "./xstate-03560826.js";
function g(e) {
  var r = S.useRef();
  return r.current || (r.current = { v: e() }), r.current.v;
}
var v = globalThis && globalThis.__assign || function() {
  return v = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, v.apply(this, arguments);
}, j = globalThis && globalThis.__rest || function(e, r) {
  var t = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      r.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (t[n[a]] = e[n[a]]);
  return t;
}, E = globalThis && globalThis.__read || function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, o = [], i;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      o.push(a.value);
  } catch (s) {
    i = { error: s };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return o;
};
function C(e, r) {
  var t = g(function() {
    return typeof e == "function" ? e() : e;
  });
  if (process.env.NODE_ENV !== "production" && typeof e != "function") {
    var n = E(O(t), 1), a = n[0];
    e !== a && console.warn("Machine given to `useMachine` has changed between renders. This is not supported and might lead to unexpected results.\nPlease make sure that you pass the same Machine as argument each time.");
  }
  var o = r.context, i = r.guards, s = r.actions, l = r.activities, f = r.services, h = r.delays;
  r.state;
  var u = j(r, ["context", "guards", "actions", "activities", "services", "delays", "state"]), c = g(function() {
    var m = {
      context: o,
      guards: i,
      actions: s,
      activities: l,
      services: f,
      delays: h
    }, p = t.withConfig(m, function() {
      return v(v({}, t.context), o);
    });
    return T(p, u);
  });
  return x(function() {
    Object.assign(c.machine.options.actions, s), Object.assign(c.machine.options.guards, i), Object.assign(c.machine.options.activities, l), Object.assign(c.machine.options.services, f), Object.assign(c.machine.options.delays, h);
  }, [s, i, l, f, h]), c;
}
globalThis && globalThis.__read;
globalThis && globalThis.__values;
function I(e, r, t) {
  if (e.status === y.NotStarted)
    return !0;
  var n = t.changed === void 0 && (Object.keys(t.children).length > 0 || typeof r.changed == "boolean");
  return !(t.changed || n);
}
var N = globalThis && globalThis.__read || function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, o = [], i;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      o.push(a.value);
  } catch (s) {
    i = { error: s };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return o;
};
function P(e) {
  return e;
}
function D(e) {
  for (var r = [], t = 1; t < arguments.length; t++)
    r[t - 1] = arguments[t];
  var n = N(r, 1), a = n[0], o = a === void 0 ? {} : a, i = C(e, o), s = d(function() {
    return i.status === y.NotStarted ? o.state ? b.create(o.state) : i.machine.initialState : i.getSnapshot();
  }, [i]), l = d(function(u, c) {
    return I(i, u, c);
  }, [i]), f = d(function(u) {
    var c = i.subscribe(u).unsubscribe;
    return c;
  }, [i]), h = w.useSyncExternalStoreWithSelector(f, s, s, P, l);
  return _(function() {
    var u = o.state;
    return i.start(u ? b.create(u) : void 0), function() {
      i.stop(), i.status = y.NotStarted;
    };
  }, []), [h, i.send, i];
}
export {
  D as u
};
